import { useState, useEffect } from "react";
import "./Avatar.css";

const isValidUrl = (url) => !!url && /^(https?:|data:|blob:)/.test(url);

/**
 * Avatar that shows the image when it loads, and falls back to a clean
 * gradient initial when the URL is missing OR fails to load (e.g. a stale /
 * 404 Google Cloud URL). Fills its parent unless `size` (px) is given.
 */
export default function Avatar({ src, name, className = "", size }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [src]);

  const initial = (name || "?").trim().charAt(0).toUpperCase() || "?";
  const dimStyle = size
    ? { width: size, height: size, fontSize: Math.round(size * 0.42) }
    : undefined;

  if (isValidUrl(src) && !failed) {
    return (
      <img
        src={src}
        alt={name || "avatar"}
        className={`cb-avatar ${className}`}
        style={dimStyle}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div className={`cb-avatar cb-avatar-initial ${className}`} style={dimStyle}>
      {initial}
    </div>
  );
}
